// extracted by mini-css-extract-plugin
module.exports = {"container":"ProposalCardClaimAwardBar_container__1q2si","content":"ProposalCardClaimAwardBar_content__2tILI","inClaimPeriod":"ProposalCardClaimAwardBar_inClaimPeriod__2XEzG"};